import React from 'react';
import moment from 'moment';

const Header = ({headerSettings, totalHeight, userSettings}) => (

  <div className="row bg-white px-3 border-bottom">
      <div className="col-6 py-2">
        <img
          src={headerSettings && headerSettings.logo_url && headerSettings.logo_url}
          alt="header"
          style={{height:'18vh'}}
        />
      </div>
      <div className="col-6 text-right pr-4 pt-2 heading-align-middle">
        <h2 className="heading-text"> 
          {userSettings && userSettings.set_date_as_title ?
            moment().format("MMMM D, YYYY")
            : userSettings.title ? userSettings.title 
            : headerSettings && headerSettings.set_date_as_title ? 
            moment().format("MMMM D, YYYY")
            : headerSettings.title && headerSettings.title
          }
        </h2>
      </div>
  </div>
);
export default Header;


// WEBPACK FOOTER //
// ./src/components/agencyMonitor/common/Header.js